import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../Styles/AdminDetails.css";
import axios from "axios";
import Loader from "../../Components/Loader";
function AdminDetails() {
  const navigate = useNavigate();
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("No authentication token found");
          return;
        }

        const response = await axios.get(
          "https://api.uniums.com/api/dashboard/all-admins",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data && response.data.data) {
          setAdmins(response.data.data);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching admin data:", error);
        setLoading(false);
      }
    };

    fetchAdmins();
  }, []);

  const handleStudentClick = (adminId) => {
    // Navigate to students page for this admin
    navigate(`/admin/${adminId}/students`);
  };

  const handleFacultyClick = (adminId) => {
    // Navigate to faculty page for this admin
    navigate(`/admin/${adminId}/faculty`);
  };

  if (loading) {
    return (
      <>
        <Loader />
        <div className="admin-details-loading">Loading admin details...</div>
      </>
    );
  }

  return (
    <div className="admin-details-main-container">
      <h2 className="admin-details-header-title">Admin Management</h2>
      <div className="admin-details-table-wrapper">
        <table className="admin-details-data-table">
          <thead>
            <tr>
              <th className="admin-details-table-header">Name</th>
              <th className="admin-details-table-header">Email</th>
              <th className="admin-details-table-header">Organization</th>
              <th className="admin-details-table-header">
                Organization Address
              </th>
              <th className="admin-details-table-header">Contact</th>
              <th className="admin-details-table-header">Status</th>
              <th className="admin-details-table-header">Actions</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((admin) => (
              <tr key={admin._id} className="admin-details-table-row">
                <td className="admin-details-table-cell">{admin.name}</td>
                <td className="admin-details-table-cell">{admin.email}</td>
                <td className="admin-details-table-cell">
                  {admin.organizationName}
                </td>
                <td className="admin-details-table-cell">
                  {admin.organizationAddress}
                </td>
                <td className="admin-details-table-cell">
                  {admin.organizationContact}
                </td>
                <td className="admin-details-table-cell">
                  <span
                    className={`admin-details-status-badge ${
                      admin.active
                        ? "admin-details-status-active"
                        : "admin-details-status-inactive"
                    }`}
                  >
                    {admin.active ? "Active" : "Inactive"}
                  </span>
                </td>
                <td className="admin-details-action-cell">
                  <button
                    className="admin-details-student-button"
                    onClick={() => handleStudentClick(admin._id)}
                  >
                    Students
                  </button>
                  <button
                    className="admin-details-faculty-button"
                    onClick={() => handleFacultyClick(admin._id)}
                  >
                    Faculty
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminDetails;
